import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { ModalInterface } from "app/interface/modal";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ProfileService } from '@core/services/profile.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonService } from '@core/services/common.service';

@Component({
    selector: 'app-account-cancel',
    templateUrl: './account-cancel.component.html',
    styleUrls: ['./account-cancel.component.scss'],
    standalone: false
})
export class AccountCancelComponent implements OnInit, AfterViewInit, ModalInterface {

    @ViewChild('AcccountCancel') modalTemplateRef: TemplateRef<any>;
    initiator: BehaviorSubject<boolean> = new BehaviorSubject(false);
    modalDialogRef: NxModalRef<any, any>;
    confirm: BehaviorSubject<SubmitEvent> = new BehaviorSubject(null);

    form: FormGroup;

    constructor(
        private dialogService: NxDialogService,
        private profileService: ProfileService,
        private commonService: CommonService,
    ) {
        this.form = new FormGroup({
            currentPassword: new FormControl('', [Validators.required]),
        });
    }

    openModal(): void {
        this.modalDialogRef = this.dialogService.open(this.modalTemplateRef, { showCloseIcon: true });
    }

    closeModal(): void {
        this.modalDialogRef.close();
    }

    ngAfterViewInit(): void {
        this.initiator.next(true);
    }

    ngOnInit(): void {
    }

    inputData = (): void => { };

    cancelAccount(): void {
        if (!this.form.valid) {
            return;
        }

        const password = this.form.get('currentPassword') ? this.form.get('currentPassword').value : null;
        this.profileService.postDeleteAccount(password).subscribe(
            {
                error: (errorResponse: HttpErrorResponse) => {
                    let errors = {};

                    const errorResponseErrors = Array.isArray(errorResponse.error)
                        ? errorResponse.error : [errorResponse.error];

                    errorResponseErrors.forEach(error => {
                        errors[error['type']] = true;
                        if (error['data']) {
                            errors[error['type']] = error['data'];
                        }
                        if (this.form.get(error['type'])) {
                            this.form.get(error['type']).setErrors({});
                        }
                    });
                    this.form.reset();
                    this.form.setErrors(errors);
                    this.form.get('currentPassword').setErrors(errors);
                },
                next: () => {
                    window.location.href = this.commonService.logoutUrl;
                },
            });
    }

}